import { THEME } from '../../constants'

const colorMapper = props => THEME.colors[props.color]

export default colorMapper
